export async function can(subject) {
    return true;
}
